export const VISITOR_ROLE   = 'visitor';
export const MEMBER_ROLE    = 'member';
export const PARTNER_ROLE   = 'partner';

export const FBG_EDITORIAL_USER = 'editorial user';
export const FBG_WEBMASTER      = 'fbg webmaster';
export const FBG_SALES_REP      = 'fbg sales rep';
export const SUPER_ADMINISTRATOR = 'super administrator';


// WEBPACK FOOTER //
// ./web/src/services/access/roles.js